import { useState } from 'react';
import { SidebarContent } from './Sidebar.jsx';
import { Drawer } from './ui';

// T121 — mobile shell. Below md, the fixed sidebar is hidden and this slim top
// bar (hamburger + wordmark) takes its place; the hamburger opens the same nav
// as a left slide-over drawer.
//
// T131 — the slide-over now renders through the shared <Drawer> primitive,
// which supplies the focus trap (+ Escape/scrim close) this drawer previously
// lacked. `mdHidden` keeps it ≥md-hidden; the nav region keeps its id for
// the hamburger's aria-controls.
export default function MobileTopBar() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="flex items-center gap-3 border-b border-slate-800 bg-slate-900/60 px-4 py-3 md:hidden">
        <button
          type="button"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
          aria-expanded={open}
          aria-controls="mobile-nav"
          className="flex h-11 w-11 items-center justify-center rounded-md border border-slate-700 text-slate-300 hover:border-brand-600 hover:text-brand-400"
        >
          ☰
        </button>
        <span className="text-lg font-semibold tracking-tight text-brand-500">hunter</span>
      </header>

      {open && (
        <Drawer
          open
          onClose={() => setOpen(false)}
          side="left"
          mdHidden
          panelClassName="w-72 max-w-[80%]"
          ariaLabel="Navigation menu"
        >
          <div id="mobile-nav" className="flex flex-1 flex-col overflow-y-auto">
            <SidebarContent onNavigate={() => setOpen(false)} />
          </div>
        </Drawer>
      )}
    </>
  );
}
